import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import unescapedText from 'I18n/utils/unescapedText';
import { Flex } from 'foundations-components/components/Flex';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { MainContentLayout } from '../components/layouts/MainContentLayout';
import { SubscriptionsCard } from '../components/Subscriptions/SubscriptionsCard';
import { GenericErrorState } from '../components/GenericErrorState';
import { useSubscriptionsData } from '../hooks/useSubscriptionsData';
import { usePollSubscriptionPaymentMethodUpdated } from '../hooks/usePollSubscriptionPaymentMethodUpdated';
import { trackPageView } from '../utils/usageTracker';
import { useAppDispatch, useAppSelector } from '../redux';
import { clearPaymentMethodUpdate, PaymentMethodUpdateStatuses, selectPaymentMethodUpdateStatus, selectPaymentMethodUpdateTarget } from '../features/PaymentMethodUpdate/PaymentMethodUpdateSlice';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SubscriptionsPage = () => {
  var _pollTarget$subscript, _pollTarget$previousM;
  const dispatch = useAppDispatch();
  const status = useAppSelector(selectPaymentMethodUpdateStatus);
  const target = useAppSelector(selectPaymentMethodUpdateTarget);
  const pollTarget = status === PaymentMethodUpdateStatuses.POLLING ? target : null;
  const isPolling = status === PaymentMethodUpdateStatuses.POLLING;
  const showSuccessAlert = status === PaymentMethodUpdateStatuses.COMPLETED_WITHOUT_TARGET;
  const {
    loading,
    error,
    data: subscriptions,
    refetch
  } = useSubscriptionsData();
  useEffect(() => {
    trackPageView('subscriptions-overview');
  }, []);
  usePollSubscriptionPaymentMethodUpdated({
    subscriptionId: (_pollTarget$subscript = pollTarget === null || pollTarget === void 0 ? void 0 : pollTarget.subscriptionId) !== null && _pollTarget$subscript !== void 0 ? _pollTarget$subscript : null,
    previousMethod: (_pollTarget$previousM = pollTarget === null || pollTarget === void 0 ? void 0 : pollTarget.previousMethod) !== null && _pollTarget$previousM !== void 0 ? _pollTarget$previousM : null
  });
  useEffect(() => {
    if (showSuccessAlert) {
      FloatingAlertStore.addAlert({
        message: unescapedText('subscriptions.paymentMethodUpdated'),
        type: 'success'
      });
      dispatch(clearPaymentMethodUpdate());
    }
  }, [showSuccessAlert, dispatch]);
  if (error) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "SUBSCRIPTIONS_OVERVIEW_LOAD",
      children: /*#__PURE__*/_jsx(MainContentLayout, {
        children: /*#__PURE__*/_jsx(GenericErrorState, {})
      })
    });
  }
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "SUBSCRIPTIONS_OVERVIEW_LOAD",
    children: /*#__PURE__*/_jsxs(MainContentLayout, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "subscriptions.title"
      }),
      children: [isPolling && /*#__PURE__*/_jsx(LoadingOverlay, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.processingPaymentMethod"
        }),
        showLabel: true
      }), /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        gap: "700",
        flexGrow: 1,
        children: /*#__PURE__*/_jsx(SubscriptionsCard, {
          subscriptions: subscriptions,
          loading: loading,
          refetch: () => void refetch()
        })
      })]
    })
  });
};